//import fill_haven_aipc from './haven/pdf-fills/approval-in-principle-checklist'
import haven_aipc from './haven/approval-in-principle-checklist'
import haven_daa from './haven/declaration-and-authorisations'
import haven_ddm from './haven/direct-debit-mandate'
import haven_gl from './haven/haven-gift-letter'
import haven_iraf from './haven/interest-rate-application-form'
import haven_coca from './haven/change-of-correspondence-address'
import haven_rfao from './haven/request-for-amended-offer'
import ptsb_mac from './ptsb/mortgage-application-for-credit'
import ptsb_msc from './ptsb/minimum-standards-checklist'
import ptsb_sod from './ptsb/sight-of-original-declaration'
import ptsb_loc from './ptsb/loan-offer-confirmation'
import ptsb_pdp from './ptsb/pre-drawdown-paye'
import ptsb_pdse from './ptsb/pre-drawdown-self-employed'
import ptsb_arf from './ptsb/amendment-request-form'
import ptsb_ddm from './ptsb/direct-debit-mandate'
import ptsb_gl from './ptsb/ptsb-gift-letter'
import avant_maduc from './avant/mortgage-application-document-upload-checklist'
import avant_bc from './avant/pdf-fills/broker-checklist'
import avant_gl from './avant/avant-gift-letter'
import avant_doi from './avant/declaration-of-identity'
import avant_acn from './avant/pdf-fills/application-cover-note'
import avant_ddm from './avant/pdf-fills/direct-debit-mandate'
import avant_loc from './avant/loan-offer-details'
import haven_cbf from './haven/cashback-form'
import haven_loc from './haven/loan-offer-checklist'
import haven_doa from './haven/deed-of-assignment'
import boi_cic from './boi/credit-intermediary-confirmations'
import boi_dc from './boi/document-checklist'
import boi_cipr from './boi/change-in-proposal-requirements'
import boi_gt from './boi/pdf-fills/boi-gift-template'
import boi_ddm from './boi/direct-debit-mandate'
import ics_dc from './ics/document-checklist'
import ics_ddm from './ics/ics-dd-mandate'
import ics_loc from './ics/loan-offer-checklist'
import ics_a from './ics/ics-application'
const templates = {
    ics:{
        'documents-checklist': ics_dc,
        'ics-dd-mandate': ics_ddm,
        'loan-offer-checklist': ics_loc,
        'ics-application': ics_a
    },
    haven:{
        'approval-in-principle-checklist': haven_aipc,
        'declaration-and-authorisations': haven_daa,
        'direct-debit-mandate': haven_ddm,
        'interest-rate-application-form': haven_iraf,
       // 'cover-note-1-app': haven_cn1app,
      //  'cover-note-2-apps': haven_cn2apps,
        'cashback-form': haven_cbf,
        'request-for-amended-offer': haven_rfao,
        'loan-offer-checklist': haven_loc,
        'deed-of-assignment': haven_doa,
        'haven-gift-letter': haven_gl,
        'change-of-correspondence-address': haven_coca,

    },
    ptsb:{
        'mortgage-application-for-credit': ptsb_mac,
        'minimum-standards-checklist': ptsb_msc,
        'sight-of-original-declaration': ptsb_sod,
        'loan-offer-confirmation': ptsb_loc,
        'pre-drawdown-paye': ptsb_pdp,
        'pre-drawdown-self-employed': ptsb_pdse,
        'direct-debit-mandate': ptsb_ddm,
        'amendment-request-form': ptsb_arf,
        'ptsb-gift-letter': ptsb_gl
    },
    boi:{
        'credit-intermediary-confirmations': boi_cic,
        'document-checklist': boi_dc,
        'change-in-proposal-requirements': boi_cipr,
        'direct-debit-mandate': boi_ddm,
        'boi-gift-template': boi_gt
    },
    avant:{
        'mortgage-application-document-upload-checklist': avant_maduc,
        //'broker-checklist': avant_bc,
        'declaration-of-identity': avant_doi,
        'application-cover-note': avant_acn,
        'direct-debit-mandate': avant_ddm,
        'loan-offer-details': avant_loc,
        'avant-gift-letter': avant_gl
    },
    sussd:{
    },
    nua:{

    }
}
export default templates